import * as React from "react";
import Stack from "@mui/material/Stack";
import {NotificationsRounded} from "@mui/icons-material";
import NavbarBreadcrumbs from "../../widget/NavbarBreadcrumbs/NavbarBreadcrumbs";
import MenuButton from "./MenuButton";
import ColorModeIconDropdown from "../../theme/ColorModeIconDropdown";
import SearchBar from "./SearchBar";
import {useAuthInfo} from "@/store/account.c";
import {roleAlias} from "@/helper/constant";
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import {ConnectCnipa} from "@/pages/Layout/ConnectCnipa";
import {Chatbot} from "@/pages/Layout/Chatbot";

export default function Header() {
    const {role: {roleAlias: roleName}} = useAuthInfo()

    return (
        <Stack
            direction="row"
            sx={{
                display: {xs: "none", md: "flex"},
                width: "100%",
                alignItems: {xs: "flex-start", md: "center"},
                justifyContent: "space-between",
                maxWidth: {sm: "100%", md: "1700px"},
                pt: 1.5,
            }}
            spacing={2}
        >
            <NavbarBreadcrumbs/>
            <Stack direction="row" sx={{gap: 1}}>
                <SearchBar/>
                {(roleName == roleAlias['superadmin'] || roleName == roleAlias['processer']) && <ConnectCnipa/>}
                <Chatbot/>
                <MenuButton aria-label="Open notifications">
                    <GridViewOutlinedIcon/>
                </MenuButton>
                <MenuButton showBadge aria-label="Open notifications">
                    <NotificationsRounded/>
                </MenuButton>
                <ColorModeIconDropdown/>
            </Stack>
        </Stack>
    );
}
